import React from 'react';
import { Link } from 'react-router-dom';
import { FiWind, FiPhone, FiMail, FiMapPin, FiClock } from 'react-icons/fi';
import SafeIcon from '../SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-primary text-white pt-16 pb-8">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          
          {/* Brand & Intro */}
          <div className="flex flex-col gap-6">
            <Link to="/" className="flex items-center gap-2">
               <div className="bg-white/10 text-white p-2 rounded-lg">
                <SafeIcon icon={FiWind} className="text-2xl" />
              </div>
              <div className="flex flex-col">
                <span className="font-heading font-bold text-xl text-white leading-none tracking-tight">
                  NORTHPEAK
                </span>
                <span className="text-[0.65rem] text-blue-200 font-semibold uppercase tracking-widest leading-none mt-1">
                  Heating & Cooling
                </span>
              </div>
            </Link>
            <p className="text-blue-100 text-sm leading-relaxed">
              Montreal's trusted choice for professional heating, cooling, and ventilation services. Keeping homes and businesses comfortable year-round with reliable, 24/7 emergency support.
            </p>
            <div className="flex gap-4">
               {/* Trust Badges Mini */}
               <img src="https://wikiconsult.com/wp-content/uploads/2025/05/google-review-wikiconsult-1.webp" alt="Google Reviews" className="h-8 object-contain bg-white rounded p-1" />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Quick Links</h4>
            <ul className="flex flex-col gap-3 text-sm text-blue-100">
              <li><Link to="/about" className="hover:text-accent transition-colors">About Us</Link></li>
              <li><Link to="/services" className="hover:text-accent transition-colors">Our Services</Link></li>
              <li><Link to="/areas" className="hover:text-accent transition-colors">Service Areas</Link></li>
              <li><Link to="/maintenance" className="hover:text-accent transition-colors">Maintenance Plans</Link></li>
              <li><Link to="/financing" className="hover:text-accent transition-colors">Financing Options</Link></li>
              <li><Link to="/quote" className="hover:text-accent transition-colors">Request an Estimate</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Top Services</h4>
            <ul className="flex flex-col gap-3 text-sm text-blue-100">
              <li><Link to="/services" className="hover:text-accent transition-colors">Furnace Installation & Repair</Link></li>
              <li><Link to="/services" className="hover:text-accent transition-colors">AC Installation & Repair</Link></li>
              <li><Link to="/services" className="hover:text-accent transition-colors">Heat Pump Systems</Link></li>
              <li><Link to="/services" className="hover:text-accent transition-colors">Mini Split Systems</Link></li>
              <li><Link to="/services" className="hover:text-accent transition-colors">Indoor Air Quality</Link></li>
              <li><Link to="/services" className="hover:text-accent transition-colors">24/7 Emergency Repairs</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Contact Us</h4>
            <ul className="flex flex-col gap-4 text-sm text-blue-100">
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiMapPin} className="text-accent mt-1 flex-shrink-0" />
                <span>5800 Boulevard Décarie<br/>Montreal, QC H3X 2J5(demo)</span>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiPhone} className="text-accent flex-shrink-0" />
                <a href="tel:5145550122" className="hover:text-white transition-colors">(514) 555-0122(demo)</a>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiMail} className="text-accent flex-shrink-0" />
                <a href="mailto:service@northpeakhvac.ca" className="hover:text-white transition-colors">service@northpeakhvac.ca(demo)</a>
              </li>
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiClock} className="text-accent mt-1 flex-shrink-0" />
                <span>
                  <strong>24/7 Emergency Service</strong><br/>
                  <span className="text-blue-200">Office: Mon-Fri 8AM–6PM</span>
                </span>
              </li>
            </ul>
          </div>

        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-blue-200">
          <p>&copy; {new Date().getFullYear()} NorthPeak Heating & Cooling. All rights reserved. Site demo only.</p>
          <div className="flex gap-4">
            <span className="hover:text-white cursor-pointer transition-colors">Privacy Policy</span>
            <span className="hover:text-white cursor-pointer transition-colors">Terms of Service</span>
            <span className="hover:text-white cursor-pointer transition-colors">Licence RBQ: 5555-1234-56(demo)</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;